import {
    DELIVERY_SLIP_UPLOADED,
    SIGN_DELIVERY_SLIP_UPLOADED,
    DELIVERY_CONFIRMED,
    PAYMENT_ISSUED,
    PAYMENT_CONFIRMED,
    PUT_CONTRACT, DELIVERY_SLIP_SIGNED, CONTRACT_APPROVED, AGREEMENT_SIGNED,
} from '../../actions/contractsActions';
import {EventEmitter, EVENTS} from '../../../api/events';
import {NotificationGroups} from '../../../components/AlertsHub';

/*
 * Redux middle ware for handling contracts events
 */
export default ({dispatch}) => next => action => {
    next(action);

    // TODO create alert object to be sent in notification payload;
    // TODO create central place for notification messages.

    const {type, payload} = action;

    // eslint-disable-next-line default-case
    switch (type) {
    case CONTRACT_APPROVED: {
        const {data: contract} = payload;

        const action = {
            type: PUT_CONTRACT,
            payload: {data: contract}
        };

        // Notify Grace Users
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'success',
                message: `Contract ${contract.contractNumber} was approved`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Grace,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    },
                }
            }
        );

        // Notify Representative
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Your contract ${contract.contractNumber} has been approved`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.CustomerRepresentatives(contract.customerId),
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );

        // Notify SMS users
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Contract ${contract.contractNumber} has been approved`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Sms,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );
        break;
    }
    case DELIVERY_SLIP_UPLOADED: {
        const {data: contract} = payload;

        // Redux action that gets sent with the notification. This performs a update to the contract when the user receives it.
        const action = {
            type: PUT_CONTRACT,
            payload: {data: contract}
        };

        // Send message to relevant Groups
        // 1. Notify SMS users
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Package Ready for contract ${contract.contractNumber} `,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Sms,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );

        // 2. Notify Customer Representatives
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Package for contract ${contract.contractNumber} is now ready.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.CustomerRepresentatives(contract.customerId),
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );

        //3. Notify GK
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Package for contract ${contract.contractNumber} is ready for customer.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Grace,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );
        break;
    }
    case DELIVERY_SLIP_SIGNED: {
        const {data: contract} = payload;

        // Redux action that gets sent with the notification. This performs a update to the contract when the user receives it.
        const action = {
            type: PUT_CONTRACT,
            payload: {data: contract}
        };

        // Send to Customer Representatives
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Delivery slip for contract ${contract.contractNumber} has been signed.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.CustomerRepresentatives(contract.customerId),
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );

        // Send to SMS users
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Delivery slip for contract ${contract.contractNumber} was signed.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Sms,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );
        break;
    }
    case SIGN_DELIVERY_SLIP_UPLOADED: {
        const {data: contract} = payload;

        // Redux action that gets sent with the notification. This performs a update to the contract when the user receives it.
        const action = {
            type: PUT_CONTRACT,
            payload: {data: contract}
        };

        // Send to Customer Representatives
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Signed Delivery slip for contract ${contract.contractNumber} was uploaded`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.CustomerRepresentatives(contract.customerId),
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );

        // Send to SMS users
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Delivery slip for contract ${contract.contractNumber} was signed.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Sms,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );
        break;
    }
    case DELIVERY_CONFIRMED: {
        const {data: contract} = payload;

        // Redux action that gets sent with the notification. This performs a update to the contract when the user receives it.
        const action = {
            type: PUT_CONTRACT,
            payload: {data: contract}
        };

        // Notify SMS users
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Contract ${contract.contractNumber} delivery has been confirmed.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Sms,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );

        // Notify Customer users.
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Contract ${contract.contractNumber} delivery has been confirmed.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.CustomerRepresentatives(contract.customerId),
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );

        // Notify GK users.
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Devices for contract ${contract.contractNumber} have been delivered.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Grace,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );
        break;
    }
    case PAYMENT_ISSUED: {
        const {data: contract} = payload;

        // Redux action that gets sent with the notification. This performs a update to the contract when the user receives it.
        const action = {
            type: PUT_CONTRACT,
            payload: {data: contract}
        };

        // Notify SMS users
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Payment on Contract ${contract.contractNumber} has been issued.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Sms,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );

        // Notify GK users.
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Payment on Contract ${contract.contractNumber} was issued.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Grace,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );
        break;
    }
    case PAYMENT_CONFIRMED: {
        const {data: contract} = payload;

        // Redux action that gets sent with the notification. This performs a update to the contract when the user receives it.
        const action = {
            type: PUT_CONTRACT,
            payload: {data: contract}
        };

        // Notify SMS users
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Payment for contract ${contract.contractNumber} was confirmed.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Sms,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );

        // Notify GK users.
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `Payment for contract ${contract.contractNumber} was confirmed.`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Grace,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );
        break;
    }
    case AGREEMENT_SIGNED: {
        const {data: contract} = payload;

        const action = {
            type: PUT_CONTRACT,
            payload: {data: contract}
        };
        // Notify Grace Users
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'success',
                message: `Contract ${contract.contractNumber} agreement signed`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.Grace,
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    },
                }
            }
        );

        // Notify Representative
        EventEmitter.dispatch(
            EVENTS.SEND_MESSAGE_TO_GROUP,
            {
                key: new Date() + Math.random(),
                type: 'default',
                message: `An agreement document has been updated for your contract, ${contract.contractNumber}`,
                payload: {
                    data: contract,
                    groupName: NotificationGroups.CustomerRepresentatives(contract.customerId),
                    meta: {
                        link: '',
                        createAlert: true,
                        action
                    }
                }
            }
        );
    }
    }
};
